module.exports = __webpack_public_path__ + "static/media/Data_insight_en_3-3.32ba9875.svg";